var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__container"},[_c('div',{staticClass:"loading-container"},[_c('video',{staticClass:"video-loading",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("./../../assets/loading_animation.mp4"),"type":"video/mp4"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }